export const REDIRECT_DELAY_MS = 3000;
export const REDIRECT_URL = "https://www.marriott.com";
export const DEFAULT_NOT_FOUND_PAGE_NAME = "Root (Not Found) Page";
export const CAMPAIGN_NOT_FOUND_PAGE_NAME = "Campaign Not Found Page";

export const getInitialSecondsLeft = (delayMs = REDIRECT_DELAY_MS) =>
  Math.ceil(delayMs / 1000);

export const tickSecondsLeft = (current) => Math.max(current - 1, 0);

export const shouldRedirectNow = (autoRedirect, secondsLeft) =>
  Boolean(autoRedirect) && secondsLeft <= 0;

export const isRootDeadEndPath = (pathname) =>
  pathname === "/" || pathname === "";

export const formatRedirectCountdown = (secondsLeft) => {
  const seconds = Math.max(secondsLeft, 1);
  const unit = seconds === 1 ? "second" : "seconds";
  return `You will be redirected to Marriott.com in ${seconds} ${unit}...`;
};
